import React, { useEffect, useState } from 'react';
import PageContainer from '../components/PageContainer';
import MainContent from '../components/MainContent';
import PageTitle from '../components/Common/PageTitle/PageTitle';
import Notification from '../components/Common/Notification';
import ActivityLoader from '../components/Common/ActivityLoader';
import { useFinder } from '../DataStore/FinderContext';
import { useTheme } from '../DataStore/ThemeContext';
import functions from '../util/functions';
import { useNavigate } from 'react-router-dom';
import { useStudent } from '../DataStore/StudentContext';
import { useStaff } from '../DataStore/StaffContext';

const FinderPage = () => {
   const [showProfile, setShowProfile] = useState(null);

  const {
        searchResults, 
        message,
        getRecentSearches,
        recentSearches,
        dispatch,
        getSuggestions,
        searchSuggestions,
        setSearchText,
        logResultClick,
    } = useFinder();

    const {loadProfile: loadStudentProfile, studentId} = useStudent();
    const {loadProfile: loadStaffProfile, staffId} = useStaff();

    useEffect(() => {
        getRecentSearches();
        getSuggestions();
    }, []);

   useEffect(()=>{
        if(studentId && showProfile ==="student"){
            navigate('/student-profile');
        }else if(staffId && showProfile === "staff"){
            navigate('/staff-profile');
        }
    }, [studentId, showProfile, staffId])

    //Reset showProfile when the component unmounts
    useEffect(() => {
        return () => {
            setShowProfile(null);
        };
    }, []);


    const { student_result, staff_result, report_result } = searchResults;
    const {openSettings} = useTheme();
    const navigate = useNavigate();



   const handleRecentClick = (results)=>{
        dispatch({type: 'searchResults', payload: results});
    }

    const composeSubtitle = (suggestion)=>{
        switch(suggestion.result_type){
            case "student":
                return `Student Reg No: ${suggestion.subtitle}`;
            case "staff":
                return `Staff Reg No: ${suggestion.subtitle}`;
            default:
                return suggestion.subtitle;
        }
    }

    const handleSuggestionClick = (item)=>{
        setSearchText(item.subtitle);
    }

    const handleResultClick = async(type, result)=>{
        switch(type){
            case "Student":
                await logResultClick('student', result.full_name, result.reg_no, result);
                break;
            case "Staff":
                await logResultClick('staff', result.full_name, result.reg_no, result);
                break;
            case "Report":
                // openSettings(type, "VendorSearchResult", result);
                await logResultClick('report', 'Academic Report', result.title, result);
                break;
                
            default:
                openSettings(type, "SearchResult", result);
        }
        
    }


    const goToStudentProfile = (profileInfo)=>{
        setShowProfile("student");
        loadStudentProfile(profileInfo.id);
    }

     const goToStaffProfile = (profileInfo)=>{
        setShowProfile("staff");
        loadStaffProfile(profileInfo.staff_id);
    }


  return (
    <PageContainer>
      <MainContent>
        <PageTitle
          title="Search Results"
          description="View results for students, staff, and reports"
          iconClass="fa fa-search"
        />



            <div className="row">
                    {/* Left Section: Recent Search */}
                    <div className="col-md-8">
                        <div className="card mb-3">
                            <div className="card-body">
                             {Array.isArray(searchSuggestions) && <>
                                <h6 className="mb-3">Search suggestion</h6>
                                <div className="d-flex">
                                    {searchSuggestions.map((item, key) => (
                                        <div key={key} className="search-entry d-flex align-items-center mr-4" onClick={()=>handleSuggestionClick(item)}>
                                            <i className="fa fa-search text-muted mr-2"></i>
                                            <div>
                                                <h6 className="mb-0">{item.title}</h6>
                                                <small className="text-muted">{composeSubtitle(item)}</small>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <hr />
                                </>}

                                <h6 className="mb-3">Recommended For You</h6>
                                <div className="row overflow-auto" style={{ maxHeight: '60vh' }}>
                                    {/* Recommended Accounts */}
                                    {Array.isArray(student_result) && <div className="col-md-6">
                                        <h6 className="text-primary">
                                            <i className="fa fa-users mr-2"></i> Students
                                        </h6>
                                        {student_result.map((item) => (
                                            <div key={item.id} className="search-entry d-flex justify-content-between align-items-center mb-3" onClick={()=>handleResultClick('Student', item)}>
                                                <div>
                                                    <h6 className="mb-0">{item.full_name} - {item.class.class_name}</h6>
                                                    <small className="text-muted">{item.reg_no}</small> <br/>
                                                     <small className="text-muted">{item.class.class_name} - {item.stream?.stream_name || 'No Stream'}</small><br />
                                                    <small className="text-muted">{item.sex}</small> <br/>
                                                     <small className="text-muted">{item.status_name}</small> {item.status*1 > 0 && <i className="fa fa-circle-check text-success"></i>} <br />
                                                    <span className='link text-info fs-12' onClick={()=>goToStudentProfile(item)}>View Profile</span>
                                                    <span className='ml-3 link text-info fs-12'>Add to list...</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>}

                                    {/* Recommended Vendors */}
                                    {Array.isArray(report_result) && <div className="col-md-6">
                                        <h6 className="text-primary">
                                            <i className="fa fa-book mr-2"></i> Reports
                                        </h6>
                                        {report_result.map((item) => (
                                            <div key={item.id} className="search-entry d-flex justify-content-between align-items-center mb-3" onClick={()=>handleResultClick('Report', item)}>
                                                <div>
                                                    <h6 className="mb-0">{item.title}</h6>
                                                    <small className="text-muted"> Year: {item.year} - Term: {item.term.term}<br />Class: {item.class.class_name}</small><br/>
                                                    <span className='link text-info fs-12' >Load Reports</span>
                                                    <span className='ml-3 link text-info fs-12'>General Marksheet</span>

                                                </div>
                                            </div>
                                        ))}
                                    </div>}

                                    {/* Recommended Transactions */}
                                    {Array.isArray(staff_result) && <div className="col-md-6 mt-4">
                                        <h6 className="text-primary">
                                            <i className="fa fa-briefcase mr-2"></i> Staff
                                        </h6>
                                        {staff_result.map((item) => (
                                            <div key={item.staff_id} className="search-entry d-flex justify-content-between align-items-center mb-3" onClick={()=>handleResultClick('Staff', item)}>
                                                <div>
                                                    <h6 className="mb-0">{item.hname}</h6>
                                                    <small className="text-muted">{item.reg_no}</small> <br/>
                                                    <small className="text-muted">{item.work_contact || 'No work contact'}</small> <br/>
                                                    <small className="text-muted">{item.gender}</small> <br/>
                                                     <small className="text-muted">{item.status_name}</small> {item.status*1 > 0 && <i className="fa fa-circle-check text-success"></i>} <br />

                                                    <span className='link text-info fs-12' onClick={()=>goToStaffProfile(item)}>View Profile</span>
                                                    <span className='ml-3 link text-info fs-12'>Add to list</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>}


                            
                                    
                                    

                                </div>

                                {!searchResults && <ActivityLoader />}
                                {searchResults === "404" && <Notification type="info" message={message} closable={false} />}

                            </div>
                        </div>
                    </div>

                    {/* Right Section: Saved Searches */}
                    <div className="col-md-4">
                        <div className="card mb-3">
                        <div className="card-header">
                            <div>
                                <h6 className="menu-header-title card-titl" style={{textTransform: 'none', fontWeight: 'normal', fontSize: '16px'}}>Recent Searches</h6>
                            </div>
                        </div>
                        <div className="card-body overflow-auto" style={{ maxHeight: '62vh' }}>
                                {Array.isArray(recentSearches) && recentSearches.map((item) => (
                                    <div key={item.id} className="search-entry d-flex align-items-center mb-3" onClick={()=>handleRecentClick(item.results)}>
                                        <i className="fa-solid fa-clock-rotate-left text-muted mr-3"></i>
                                        <div>
                                            <h6 className="mb-0">Filter: {item.keyword}</h6>
                                            <small className="text-muted">{functions.formatDate(item.date)}</small>
                                        </div>
                                    </div>
                                ))}
                                {/* <Link to="/saved-searches" className="text-primary">
                                    See All Saved Searches
                                </Link> */}
                                {recentSearches === '404' && <Notification type='light' message='No recent searches found' closable={false}/>}
                                {!recentSearches && <ActivityLoader />}
                            </div>
                        </div>
                    </div>
                </div>
                            





        
      </MainContent>
    </PageContainer>
  );
};

export default FinderPage;
